<template>
  <div
    class="crm-row"
    style="width: 100%"
  >
    <div
      class="crm-column"
      style="display: flex; align-items: center;"
    >
      <div style="width: calc(100% - 30px)">
        <div class="crm-input-label">
          Название клиники
        </div>
        <base-async-select
          v-model="value[index]"
          class="crm-select"
          :fetch-function="fetchClinics"
          server-paginated
          fluid
          option-title="name"
          loading-title="Загрузка клиник"
          no-options-title="Клиника не найдена"
        />
      </div>
      <icon-delete
        style="width: 30px"
        class="delete-icon"
        @click.stop="() => $emit('delete', index)"
      />
    </div>
  </div>
</template>

<script>
import {
  BaseAsyncSelect,
} from '@/components/base';

import IconDelete from 'assets/images/delete_icon.svg';

export default {
  name: 'LegalEntityClinic',
  components: {
    BaseAsyncSelect,
    IconDelete,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    async fetchClinics({ skip, take, query }) {
      const clinics = await this.$store.dispatch(this.$types.CLINICS_FETCH, {
        skip,
        take,
        filter: {
          query,
        },
      });

      return clinics.map((clinic) => ({ id: clinic.id, name: clinic.title }));
    },
  },
};
</script>

<style lang="scss" scoped>
.crm-row {
  display: flex;
  margin-top: 30px;
}
.crm-column {
  flex: 1;
  max-width: 100%;

  & + & {
    margin-left: 30px;
  }
}

::v-deep.crm-icon {

  &:not(last-child) {
    margin-bottom: 15px;
  }

  &:hover {
    cursor: pointer;

    rect {
      stroke: #6E88F3;
    }
    path {
      fill: $blue;
    }
  }
}

::v-deep.crm-form-field {
  input {
    padding: 11px 10px 12px;
    resize: none;
  }
}

.crm-input-label {
  color: #707070;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  margin-bottom: 8px;
}

.delete-icon {
  margin-left: 10px;
  position: relative;
  top: 12px;
  cursor: pointer;
}
</style>
